import React from 'react';
import { trackCheckoutStart } from '../lib/metaPixel';

/** Every CTA on the page points at this single checkout. */
export const CHECKOUT_URL = 'https://babysleepbible.impultienda.ar/checkout';
export const CURRENCY_NOTE = 'Payments are processed in your local currency';
interface CtaButtonProps {
  label: string;
  className?: string;
  size?: 'md' | 'lg';
}
export function CtaButton({
  label,
  className = '',
  size = 'lg'
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-7 py-4 text-[13px] sm:text-sm' : 'px-5 py-3 text-[13px]';
  return <a href={CHECKOUT_URL} onClick={trackCheckoutStart} className={`group inline-flex items-center justify-center gap-2.5 rounded-[11px] bg-brand-charcoal font-body font-semibold uppercase tracking-[0.08em] text-brand-white transition-colors duration-200 ease-out hover:bg-[#1d292b] focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-charcoal focus-visible:ring-offset-2 focus-visible:ring-offset-brand-white ${sizing} ${className}`} data-id="element-1" data-mp="ljeboozazbmw">
      <span data-id="element-2" data-mp="35yh880vc5245">{label}</span>
      <span aria-hidden="true" className="text-base font-normal transition-transform duration-200 ease-out group-hover:translate-x-1" data-id="element-3" data-mp="35z8xktyca3lz">
        →
      </span>
    </a>;
}
interface CtaBlockProps {
  label: string;
  /** Line shown under the button (e.g. what is included). */
  microcopy?: string;
  className?: string;
}

/**
 * Centered checkout block: local-currency note above the button, optional
 * microcopy below it. Used for every in-page purchase opportunity.
 */
export function CtaBlock({
  label,
  microcopy,
  className = ''
}: CtaBlockProps) {
  return <div className={`flex flex-col items-center text-center ${className}`} data-id="element-4" data-mp="1jpv8f1yeouv">
      <p className="font-body text-[11px] uppercase tracking-[0.14em] text-brand-charcoal/50" data-id="element-5" data-mp="6gppzttcs56o">
        {CURRENCY_NOTE}
      </p>
      <CtaButton label={label} className="mt-3 w-full sm:w-auto" data-id="element-6" data-mp="bf0zu4jnefow" />
      {microcopy && <p className="mt-3 font-body text-[12px] tracking-[0.06em] text-brand-charcoal/55" data-id="element-7" data-mp="gggmg11h4u9e">
          {microcopy}
        </p>}
    </div>;
}